import React, { useEffect, useState, createContext, useContext } from 'react';
import { en } from '../locales/en';
import { pt } from '../locales/pt';
type Language = 'en' | 'pt';
type Translations = typeof en;
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (path: string) => string | any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [lang, setLangState] = useState<Language>('en');
  useEffect(() => {
    const savedLang = localStorage.getItem('lucy_lang') as Language;
    if (savedLang && (savedLang === 'en' || savedLang === 'pt')) {
      setLangState(savedLang);
    }
  }, []);
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('lucy_lang', newLang);
  };
  const t = (path: string) => {
    const keys = path.split('.');
    let current: any = lang === 'en' ? en : pt;
    for (const key of keys) {
      if (current[key] === undefined) {
        console.warn(`Translation key not found: ${path}`);
        return path;
      }
      current = current[key];
    }
    return current;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-116">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};